import React, { memo, useEffect, useMemo, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { DRNDateUtil } from '@traveloka/district-util';
import isSameMonth from 'date-fns/isSameMonth';
import BMText from '../Text/BMText';
import { useLocale } from './context';
import IcSystemChevronLeft from '@traveloka/district-icon/IcSystemChevronLeft';
import IcSystemChevronRight from '@traveloka/district-icon/IcSystemChevronRight';
import IcSystemChevronUp from '@traveloka/district-icon/IcSystemChevronUp';
import IcSystemChevronDown from '@traveloka/district-icon/IcSystemChevronDown';
import { BMPrimitives, useBMTheme } from '../../theme';
import BMButtonIcon from '../ButtonIcon/BMButtonIcon';
/**
 * MonthCell component
 *
 * Juni 2022               < >
 */
function MonthCell(props) {
    const { activeTheme, BMComponents } = useBMTheme();
    const [styles, setStyles] = useState(() => MonthCellsStyles(BMComponents));
    const { language, country } = useLocale();
    const { year, month, horizontal, minDate, maxDate, onPrevMonthPress, onNextMonthPress, hideArrows } = props;
    const currentMonthDate = new Date(year, month);
    const isPrevMonthDisabled = isSameMonth(currentMonthDate, minDate);
    const isNextMonthDisabled = isSameMonth(currentMonthDate, maxDate);
    const monthName = useMemo(() => {
        const fullLocale = `${language}-${country}`;
        let dateFormat = 'MMMM yyyy';
        switch (fullLocale) {
            case 'en-jp':
            case 'en-kr':
                dateFormat = 'yyyy MMMM';
                break;
            case 'ja-jp':
                dateFormat = "yyyy'年' MMMM";
                break;
            case 'ko-kr':
                dateFormat = "yyyy'년' MMMM";
                break;
            default:
                break;
        }
        return DRNDateUtil.dateToString(new Date(year, month), dateFormat, {
            locale: language,
        });
    }, [year, month, language, country]);
    useEffect(() => {
        setStyles(() => MonthCellsStyles(BMComponents));
    }, [activeTheme]);
    return (<View style={styles.container}>
      {!hideArrows && horizontal && (<BMButtonIcon Icon={IcSystemChevronLeft} onPress={() => {
                if (isPrevMonthDisabled)
                    return;
                onPrevMonthPress();
            }} size={'INSET'} disabled={isPrevMonthDisabled}/>)}
      <View style={[styles.monthContainer, { alignItems: horizontal ? 'center' : 'flex-start' }]}>
        <BMText variant="titleNormal" style={styles.month}>
          {monthName}
        </BMText>
      </View>
      {!hideArrows && (<View style={styles.navigatorContainer}>
          {!horizontal && (<BMButtonIcon Icon={IcSystemChevronUp} onPress={() => {
                    if (isPrevMonthDisabled)
                        return;
                    onPrevMonthPress();
                }} size={'INSET'} disabled={isPrevMonthDisabled}/>)}
          <View style={styles.spacer}/>
          <BMButtonIcon Icon={horizontal ? IcSystemChevronRight : IcSystemChevronDown} onPress={() => {
                if (isNextMonthDisabled)
                    return;
                onNextMonthPress();
            }} size={'INSET'} disabled={isNextMonthDisabled}/>
        </View>)}
    </View>);
}
const MonthCellsStyles = (BMComponents) => StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: BMPrimitives.BMSize.md,
        paddingVertical: BMPrimitives.BMSize.sm,
        backgroundColor: BMComponents.BMUiCalendarBgcolorPrimary,
    },
    monthContainer: {
        flex: 1,
    },
    month: {
        color: BMComponents.BMUiCalendarInkDatePrimary,
        flex: 1,
    },
    navigatorContainer: {
        alignSelf: 'flex-end',
        flexDirection: 'row',
    },
    spacer: {
        width: 16,
    },
});
export default memo(MonthCell);
